// extracted by mini-css-extract-plugin
export default {"block":"HomeworkDetail_block__1hpl7","header":"HomeworkDetail_header__Y0gq3","footer":"HomeworkDetail_footer__I2hXt"};